import React from 'react';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import { withStyles, Typography, Button } from '@material-ui/core';

const styles = {
  titleWrapper: {
    display: 'flex',
    alignItems: 'center',
    paddingTop: '21px',
    backgroundColor: 'rgba(237,237,237,0.5)'
  },
  padded: {
    padding: '22px 0'
  },
  title: {
    color: '#212322',
    fontWeight: '400',
    marginLeft: '16px',
    fontSize: '24px',
    lineHeight: '30px',
  },
  button: {
    padding: '0',
    minHeight: 'auto',
    minWidth: 'auto',
    marginLeft: '24px',
    color: '#00A1A1'
  }
};

const EditPageTitle = ({title, classes, padded, onBack}) => (
  <div className={`${classes.titleWrapper} ${padded ? classes.padded : ''}`}>
    <Button aria-label="Back" onClick={()=>onBack()} className={classes.button}>
      <ArrowBackIcon/>
    </Button>
    <Typography className={classes.title} variant="h6">
      {title}
    </Typography>
  </div>
);

export default withStyles(styles)(EditPageTitle);
